module.exports = __webpack_public_path__ + "static/media/ic_more_tool_gray.279debef.svg";